import {
    Badge,
    Box,
    Button,
    ButtonGroup,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    FormControlLabel,
    Grid2
} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import Card from "@mui/material/Card";
import {Link, useNavigate} from "react-router-dom";
import AuthContext from "../Services/AuthContext";
import {AccountBalance, Add, Delete, Edit, Event, Key, ManageAccounts} from "@mui/icons-material";
import Switch from '@mui/material/Switch';
import Main from "../Layout/Main";
import AddOrganizer from "../Panel/Organizer/AddOrganizer";
import IconButton from "@mui/material/IconButton";

function Organizer() {
    const [user] = useContext(AuthContext);
    const [items, setItems] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [archived, setArchived] = useState(false);
    const [cards, setCards] = useState([]);

    const [addOrganizer, setAddOrganizer] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/organizer`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setItems(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [user, refresh]);

    function _delete(id) {
        fetch(`/api/organizer/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        setCards(items.filter((it) => {return archived || it.all_camps === 0 || it.active_camps}).map((item) => <Grid2 item size={{xs: 12, sm: 6, md: 4}} key={item.id}>
            <Card>
                <CardHeader title={item.name} subheader={item.organization} action={<IconButton onDoubleClick={() => _delete(item.id)} color={'error'}><Delete /></IconButton>}/>
                <CardContent sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                    <Box
                        sx={{backgroundColor: 'warning.main', borderRadius: '0.375rem'}}
                        variant="contained"
                        bgColor={'warning'}
                        color={'white'}
                        borderRadius="5"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="6rem"
                        height="6rem"
                    >
                        <AccountBalance fontSize={'large'} color={'white'}/>
                    </Box>
                </CardContent>

                <Divider/>

                <CardActions sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                    <ButtonGroup>
                        <Badge badgeContent={item.active_camps} color={'info'}><Link
                            to={`/organizer/${item.id}/camps`}><Button
                            variant={'outlined'} color={'info'} startIcon={<Event />}>Wydarzenia</Button></Link></Badge>
                        <Link to={`/organizer/${item.id}/settings`}><Button color={'info'} variant={'outlined'} startIcon={<ManageAccounts />}>Ustawienia</Button></Link>
                    </ButtonGroup>
                </CardActions>
            </Card>
        </Grid2>));
    }, [archived, items]);

    return (<Main title={'Organizatorzy'} actions={<>
        <FormControlLabel control={<Switch onChange={() => setArchived(a => !a)} checked={archived} />} label="Archiwalni" />
        {user.isAnyAdmin && <Button variant={'contained'} startIcon={<Add />} onClick={() => setAddOrganizer(true)}>Dodaj Organizatora</Button>}
    </>}>
        <Grid2 container spacing={4} justifyContent={'space-around'} flexWrap={'wrap'} sx={{width: '95vw'}}>
            {cards}
        </Grid2>
        <AddOrganizer isOpen={addOrganizer} dismiss={() => setAddOrganizer(false)} onSuccess={() => setRefresh(r => ++r)} />
    </Main>);
}

export default Organizer;